// Spec 4.8 reduced the immunocompromised assessment to a plain question, and these are
// the only two codes that answer it. Records first reported under 4.3 hold one of
// X0068-1..4, which name *when* the patient was immunocompromised — a question 4.8 never
// asks — so their codes cannot be rendered as Yes/No without inventing an answer.
export const YES_NO_IMMUNOCOMPROMISED_CODES = ["X0068-5", "X0068-6"];

/**
 * Whether a set of immunocompromised options is the Yes/No pair, and so can be asked as
 * a radio. Keyed on the codes the server sent rather than on the specification version,
 * so a set this does not recognise stays a select instead of disappearing.
 */
export const isYesNoImmunocompromisedSet = (options) =>
  (options || []).length === YES_NO_IMMUNOCOMPROMISED_CODES.length &&
  (options || []).every(({ value }) =>
    YES_NO_IMMUNOCOMPROMISED_CODES.includes(value)
  );

/**
 * The risk-factor codes a form should hold once the server has re-derived its defaulted
 * risks.
 *
 * Defaulted codes are withdrawn as well as added, because the server derives them from
 * the treatment date: open the form on a date where the patient is 61 and the age
 * Indication ticks itself, then correct the date to one where they are 59, and a purely
 * additive merge leaves the tick behind — asserting an eligibility the patient does not
 * have (KIN-1870). Codes the clinician ticked themselves are never touched.
 *
 * An existing record is returned unchanged. Its codes are what was reported to NIIS, and
 * re-deriving them on open would edit history rather than the form.
 */
export const mergeDefaultedRiskCodes = ({
  currentCodes = [],
  defaultedRisks = [],
  isEditMode = false,
}) => {
  const selectedCodes = defaultedRisks
    .filter((risk) => risk.selected)
    .map((risk) => risk.code);

  if (isEditMode) {
    return [...new Set([...currentCodes, ...selectedCodes])];
  }

  const serverOwnedCodes = defaultedRisks.map((risk) => risk.code);
  const clinicianChoices = currentCodes.filter(
    (code) => !serverOwnedCodes.includes(code)
  );

  return [...new Set([...clinicianChoices, ...selectedCodes])];
};
